import script from "./SynchronizationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SynchronizationSettings.vue?vue&type=script&setup=true&lang=js"

import "./SynchronizationSettings.vue?vue&type=style&index=0&id=28c0994b&lang=scss&scoped=true"
import "./SynchronizationSettings.vue?vue&type=style&index=1&id=28c0994b&lang=scss"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c0994b"]])

export default __exports__